<div class="stepper-container h-100" [ngClass]="{'cx-one-ui': isCxone}">
    	<!-- cxone loader -->
        <sol-spinner *ngIf="this.pspes.isSavingProduct" [showSpinner]="true" class="spinner-positioning"></sol-spinner>
		<!-- end cxone loader -->
    <div id="cvpsne-header-container" class="cxone col-12 d-flex flex-column">
        <div class="w-100 d-flex flex-row justify-content-between">
            <div class="d-flex flex-column">
                <h1 class="cvpsne-h1-marketplace-managment cursor-h1" cvLocalizedText langSection="MarketPlace_Management"
                    langKey="MarketPlace_Management" (click)="cancel()">Marketplace Management</h1>
                <h1 class="cvpsne-h1-new-product">{{getWizardHeader()}}</h1>
            </div>
            <div class="cvpsne-buttons-navigation">
                <button id="btn-point-store-product-cancel" type="button" [disabled]="pspes.isSavingProduct" class="cxone-btn btn btn-big btn-secondary"
                    (click)="cancel()">
                    <span cvLocalizedText langSection="MarketPlace_Management" langKey="Cancel">Cancel</span>
                </button>
                <button id="btn-point-store-product-next-save" type="button" class="cxone-btn btn btn-big btn-primary"
                    (click)="validForm() ? next(): ''" [disabled]="stepper.selectedIndex === 4 ? (checkProductsEqual() || pspes.isSavingProduct) : !validForm()">
                    <span cvLocalizedText langSection="MarketPlace_Management" langKey="Next"
                        *ngIf="(stepper.selectedIndex + 1) < steppersCompleted.length">Next</span>
                    <span cvLocalizedText langSection="Common" langKey="Save_Button"
                        *ngIf="(stepper.selectedIndex + 1) == steppersCompleted.length">Save</span>
                </button>
            </div>
        </div>
    </div>
    <div class="progress-wrapper" [hidden]="loadingProgressWrapper"
        [ngStyle]="{'padding-left': stepperIndicatorBar, 'padding-right': stepperIndicatorBar }">
        <div class="progressbar empty"></div>
        <div class="progressbar filledin" [ngStyle]="{width: progressbarFilledIn + '%'}"></div>
    </div>
    <div id="cvpsne-body-container" class="col-12">
        <mat-horizontal-stepper #stepper id="cv-horizontal-stepper" class="h-100" labelPosition="bottom"
            [disableRipple]="true" [@.disabled]="true" [linear]="!isEdit ? true : !validPreviousForm(4)" (selectionChange)="onselectionChange($event)"
            [selectedIndex]="getCurrentWizardIndex()">
            <ng-template matStepperIcon="edit" let-index="index">
                <svg class="icon-16 fill-casper cvpsne-stepper-icon-done" *ngIf="stepper.selectedIndex > index">
                    <use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use>
                </svg>
                <span class="cvpsne-stepper-icon-done-back" *ngIf="stepper.selectedIndex < index">
                    {{index + 1}}
                </span>
            </ng-template>
            <ng-template matStepperIcon="done" let-index="index">
                <svg class="icon-16 fill-casper cvpsne-stepper-icon-done" *ngIf="stepper.selectedIndex > index">
                    <use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use>
                </svg>
                <span class="cvpsne-stepper-icon-done-back" *ngIf="stepper.selectedIndex < index">
                    {{index + 1}}
                </span>
            </ng-template>
            <mat-step [stepControl]="stepOneFormGroup" [completed]="isEdit ? validForm(0) : validPreviousForm(1)" [editable]="!pspes.isSavingProduct"
                [aria-label]="pspes.isSavingProduct ? 'not-allowed': ''">
                <ng-template matStepLabel>
                    <div class="cxone-tooltip-step-container" #stepOneContainer
                        tooltip='{{stepOneLabelMessage}}'
                        containerClass="cxone-tooltip-step-name" container="body" placement="bottom">
                        <span class="cvpsne-stepper-label" #stepOneLabel
                            [ngClass]="{'cvpsne-stepper-label-selected': stepper.selectedIndex == 0}" cvLocalizedText
                            langSection="MarketPlace_Management" langKey="Product_Info">
                            Product Info
                        </span>
                    </div>
                </ng-template>
                <cv-point-store-product-information-cxone [formDataBinding]="stepOneFormGroup" (detectChangesForm)="detectChangesParent()"
                    *ngIf="isCxone"></cv-point-store-product-information-cxone>
            </mat-step>
            <mat-step [stepControl]="stepTwoFormGroup" [completed]="isEdit ? validForm(1) : validPreviousForm(2)" [editable]="!pspes.isSavingProduct"
                [aria-label]="validPreviousForm(1) == false || pspes.isSavingProduct ? 'not-allowed': ''">
                <ng-template matStepLabel>
                    <div class="cxone-tooltip-step-container" #stepTwoContainer
                        tooltip='{{stepTwoLabelMessage}}'
                        containerClass="cxone-tooltip-step-name" container="body" placement="bottom">
                        <span class="cvpsne-stepper-label" #stepTwoLabel
                            [ngClass]="{'cvpsne-stepper-label-selected': stepper.selectedIndex == 1}" cvLocalizedText
                            langSection="MarketPlace_Management" langKey="Display_Settings">
                            Display Settings
                        </span>
                    </div>
                </ng-template>
                <cv-point-store-product-setting-cxone *ngIf="isCxone"
                    [formDataBinding]="stepTwoFormGroup" [stepper]="stepper"></cv-point-store-product-setting-cxone>
            </mat-step>
            <mat-step [stepControl]="stepThreeFormGroup" [completed]="isEdit ? validForm(2) : validPreviousForm(3)" [editable]="!pspes.isSavingProduct"
                [aria-label]="validPreviousForm(2) == false || pspes.isSavingProduct ? 'not-allowed': ''">
                <ng-template matStepLabel>
                    <div class="cxone-tooltip-step-container" #stepThreeContainer
                        tooltip='{{stepThreeLabelMessage}}'
                        containerClass="cxone-tooltip-step-name" container="body" placement="bottom">
                        <span class="cvpsne-stepper-label" #stepThreeLabel
                            [ngClass]="{'cvpsne-stepper-label-selected': stepper.selectedIndex == 2}" cvLocalizedText
                            langSection="MarketPlace_Management" langKey="Upload_Images">
                            Upload Images
                        </span>
                    </div>
                </ng-template>
                <cv-point-store-product-upload-cxone *ngIf="isCxone"
                    [formDataBinding]="stepThreeFormGroup" (areValidVariationImages)="areValidImageVariations()"></cv-point-store-product-upload-cxone>
            </mat-step>
            <mat-step [stepControl]="stepFourFormGroup" [completed]="isEdit ? validForm(3) : validPreviousForm(4)" [editable]="!pspes.isSavingProduct"
                [aria-label]="validPreviousForm(3) == false || pspes.isSavingProduct ? 'not-allowed': ''">
                <ng-template matStepLabel>
                    <div class="cxone-tooltip-step-container" #stepFourContainer
                        tooltip='{{stepFourLabelMessage}}'
                        containerClass="cxone-tooltip-step-name" container="body" placement="bottom">
                        <span class="cvpsne-stepper-label" #stepFourLabel
                            [ngClass]="{'cvpsne-stepper-label-selected': stepper.selectedIndex == 3}" cvLocalizedText
                            langSection="MarketPlace_Management" langKey="Assign_Groups">
                            Assign Groups
                        </span>
                    </div>
                </ng-template>
                <cv-point-store-product-assignment-cxone *ngIf="isCxone"
                    [formDataBinding]="stepFourFormGroup"></cv-point-store-product-assignment-cxone>
            </mat-step>
            <mat-step [stepControl]="stepFiveFormGroup" [completed]="isEdit ? validForm(4) : false" [editable]="!pspes.isSavingProduct"
                [aria-label]="validPreviousForm(4) == false || pspes.isSavingProduct ? 'not-allowed': ''">
                <ng-template matStepLabel>
                    <div class="cxone-tooltip-step-container" #stepFiveContainer
                        tooltip='{{stepFiveLabelMessage}}'
                        containerClass="cxone-tooltip-step-name" container="body" placement="bottom">
                        <span class="cvpsne-stepper-label" #stepFiveLabel
                            [ngClass]="{'cvpsne-stepper-label-selected': stepper.selectedIndex == 4}" cvLocalizedText
                            langSection="MarketPlace_Management" langKey="Summary">
                            Summary
                        </span>
                    </div>
                </ng-template>
                <cv-point-store-product-summary-cxone *ngIf="isCxone && stepper.selectedIndex == 4"
                    [formDataBinding]="stepFiveFormGroup"></cv-point-store-product-summary-cxone>
            </mat-step>
        </mat-horizontal-stepper>
    </div>
</div>
